import { atom } from 'recoil';
import { FormModalField } from './types';
import { ConfirmationModalType } from './constants';
import React from 'react';

const confirmationModalAtom = atom<{
  isOpen: boolean;
  message?: string | React.ReactNode;
  onConfirm?: (dontShowAgainCheck?: boolean) => undefined | void;
  onDestructiveConfirm?: () => void | undefined;
  title: string;
  confirmationText?: string;
  secondaryText?: string;
  destructiveText?: string;
  showSecondaryButton?: boolean;
  onSecondaryClick?: () => void;
  cancelText?: string;
  modalType: ConfirmationModalType;
  onClose?: () => void;
  width?: number;
  hideCancel?: boolean;
  showDontShowAgainCheckbox?: boolean;
}>({
  key: 'confirmationModalAtom',
  default: {
    isOpen: false,
    message: undefined,
    title: '',
    onConfirm: () => undefined,
    onDestructiveConfirm: () => undefined,
    confirmationText: undefined,
    destructiveText: undefined,
    cancelText: undefined,
    secondaryText: undefined,
    showSecondaryButton: false,
    onSecondaryClick: () => undefined,
    modalType: ConfirmationModalType.DEFAULT,
    onClose: () => undefined,
    width: undefined,
    hideCancel: false,
    showDontShowAgainCheckbox: false
  }
});

const formModalAtom = atom<{
  isOpen: boolean;
  title: string;
  subtitle?: string;
  onSubmit?: (values: any) => void;
  fields: FormModalField[];
  submitText?: string;
}>({
  key: 'formModalAtom',
  default: {
    isOpen: false,
    title: '',
    onSubmit: undefined,
    submitText: undefined,
    fields: []
  }
});

const successModalAtom = atom<{
  isOpen: boolean;
  title: string;
  subtitle?: string;
  onConfirm?: () => void;
}>({
  key: 'successModalAtom',
  default: {
    isOpen: false,
    title: '',
    subtitle: '',
    onConfirm: () => undefined
  }
});

const inputModalAtom = atom<{
  isOpen: boolean;
  title: string;
  inputLabel: string;
  inputSubLabel?: string;
  onConfirmClick: (inputtedValue: string) => void;
  initialValue?: string;
}>({
  key: 'inputModalAtom',
  default: {
    isOpen: false,
    title: '',
    inputLabel: '',
    onConfirmClick: () => undefined,
    initialValue: '',
    inputSubLabel: undefined
  }
});

export {
  confirmationModalAtom,
  formModalAtom,
  successModalAtom,
  inputModalAtom
};
